import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "När krävs ordningsvakter på en restaurang?";
const SHORT_ANSWER = "Kommunen kan ställa krav på ordningsvakter när verksamheten har sen serveringstid, mycket stora gästflöden eller historik av ordningsstörningar.";

export const Route = createFileRoute("/fraga/vad-ar-ordningsvakter-och-nar-kravs-de")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "När krävs ordningsvakter på en restaurang" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Beslutet om ordningsvakter regleras främst genom polismyndigheten enligt ordningslagen. Kravet kan villkoras i ditt serveringstillstånd. Vid sena öppettider är det normalt obligatoriskt."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Ordning, nykterhet och vakter" }}
      related={[{"to": "/fraga/vad-galler-vid-tillsynsbesok", "label": "Vad gäller vid ett tillsynsbesök?"}, {"to": "/fraga/vad-hander-om-jag-far-en-anmarkning", "label": "Vad händer om jag får en anmärkning vid tillsyn?"}, {"to": "/fraga/far-personalen-dricka-pa-jobbet", "label": "Får personalen dricka alkohol under arbetspasset?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "När krävs ordningsvakter på en restaurang?" },
      { name: "description", content: "Kommunen kan ställa krav på ordningsvakter när verksamheten har sen serveringstid, mycket stora gästflöden eller historik av ordningsstörningar." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-ordningsvakter-och-nar-kravs-de" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-ordningsvakter-och-nar-kravs-de" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-ordningsvakter-och-nar-kravs-de",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "När krävs ordningsvakter på en restaurang", url: "https://alkoholprovet.se/fraga/vad-ar-ordningsvakter-och-nar-kravs-de" },
      ]),
    ],
  }),
});
